import { AspectRatio, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const InsulationMobile = () => {
  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      pt={{
        base: '40px',
        sm: '10px'
      }}
      pb={0}
      flexDir={{
        base: 'column-reverse',
        md: 'row'
      }}
      alignItems="center"
    >
      <VStack
        w={{
          base: '100%',
          sm: '80%'
        }}
        position="relative"
        mt="28px"
        justifyContent="flex-end"
      >
        <AspectRatio
          w={{
            base: '180px',
            sm: '260px'
          }}
          ratio={417 / 385}
          position="relative"
          zIndex={10}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/dou-tumbler-1711955976217.png"
            alt="tumbler guarantee"
            fill
          />
        </AspectRatio>
      </VStack>
      <VStack
        w={{
          base: '100%',
          sm: '80%'
        }}
        mt={{
          base: '0px',
          sm: '40px'
        }}
        alignItems="flex-start"
        pb={{
          base: 0
        }}
      >
        <HStack w="100%" justifyContent="center">
          <VStack gap={0}>
            <AspectRatio
              w={{
                base: '40px',
                sm: '50px'
              }}
              ratio={1 / 1}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-cool-1711633012268.png"
                alt="keep cool"
                fill
              />
            </AspectRatio>
            <Text
              fontSize={13}
              fontWeight={500}
              lineHeight="16px"
              textAlign="left"
              w={{
                base: '90px',
                sm: '100px',
                md: '120px'
              }}
              mt={2}
            >
              Keep cold for up to 24 hours
            </Text>
          </VStack>

          <VStack gap={0}>
            <AspectRatio
              w={{
                base: '40px',
                sm: '50px'
              }}
              ratio={1 / 1}
              position="relative"
              zIndex={10}
            >
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/keep-warm-1711633012268.png"
                alt="keep warm"
                fill
              />
            </AspectRatio>
            <Text
              fontSize={13}
              fontWeight={500}
              lineHeight="16px"
              textAlign="left"
              w={{
                base: '90px',
                sm: '100px',
                md: '120px'
              }}
              mt={2}
            >
              Keep warm for up to 12 hours
            </Text>
          </VStack>
        </HStack>

        <Text
          w="100%"
          textStyle="gripMainTitle"
          textTransform="uppercase"
          textAlign="left"
          mt={{
            base: 2,
            sm: 5
          }}
        >
          SUPERIOR INSULATION
        </Text>
        <Text
          w="100%"
          textStyle="gripContentSmall"
          textAlign="justify"
          mb={{
            base: '8px',
            sm: '20px'
          }}
        >
          Say goodbye to lukewarm drinks! Our tumbler features superior
          double-wall vacuum insulation that keeps your beverages cold for up to
          24 hours and hot for up to 12 hours. No matter the weather, enjoy your
          drinks at the perfect temperature.
        </Text>
      </VStack>
    </Flex>
  )
}

export default InsulationMobile
